import { Mail } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import Reveal from "@/components/Reveal";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="py-24 lg:py-32 bg-zinc-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-white max-w-3xl leading-tight">
          Planning Your Next Project?
        </h2>
        <p className="mt-6 text-base lg:text-lg leading-relaxed text-zinc-400 max-w-xl">
          Let&apos;s discuss your requirements and turn your space into something better.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <button
            data-testid="cta-quote-btn"
            onClick={() => scrollToId("contact")}
            className="bg-white text-zinc-950 text-sm font-semibold px-8 py-4 rounded-sm hover:bg-zinc-200 transition-colors duration-300"
          >
            Get a Free Quote
          </button>
          <button
            data-testid="cta-contact-btn"
            onClick={() => scrollToId("contact")}
            className="border border-zinc-600 text-white text-sm font-semibold px-8 py-4 rounded-sm hover:bg-zinc-800 transition-colors duration-300"
          >
            Contact Us
          </button>
        </div>
        <a
          data-testid="cta-email-link"
          href="mailto:srbh9549@gmail.com"
          className="mt-10 inline-flex items-center gap-3 text-sm text-zinc-300 hover:text-white transition-colors duration-300"
        >
          <Mail className="w-4 h-4" strokeWidth={1.5} />
          Email: srbh9549@gmail.com
        </a>
        </Reveal>
      </div>
    </section>
  );
}
